import { jsx as _jsx } from "react/jsx-runtime";
import './Component_SL_Button.scss';
import { resolveWidth } from '../consts.js';
export const Component_SL_Button = (p) => {
    const width = p.width ?? 90;
    const height = p.height ?? 24;
    const resolvedWidth = resolveWidth(width, [100, 200]);
    return _jsx("div", { className: 'csl-button', style: { width: resolvedWidth, height }, children: p.children });
};
//# sourceMappingURL=Component_SL_Button.js.map